import { mapGetters } from 'vuex';
import mvtMarket from '@/common/components/mvtmarket/mvt-market.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';

export default {
    name: 'dspMarket',
    inject: ['$eventBus'],
    components: {
        mvtMarket,
        mvtLazyload,
    },
    computed: {
        ...mapGetters('dsp', ['dsp']),
        loadChart() {
            return this.dsp.geo.cityId && this.dsp.geo.countyId && this.dsp.geo.state;
        },
    },
    methods: {
        completed() {
            this.$refs.marketchart.ready();
        },
    },
};
